import getJsonFromUrl from './get-json-from-url';
import substr from './substr';

const utils = {
  getJsonFromUrl,
  substr,
};

export default utils;
